import '../scss/style.scss';
import { nodeListForEach } from './addons/polyfills';
import Accordeon from './modules/Accordeon';
import Menu from './modules/Menu';
import Pills from './modules/Pills';
import SlideBox from './modules/SlideBox';
import VideoPlay from './modules/VideoPlay';
import Slider from './modules/Slider';
import Tabs from './modules/Tabs';
import ScrollToTop from './modules/ScrollToTop';
import IlnOverflow from './modules/IlnOverflow';
import Header from './modules/Header';
import ShowAllIln from './modules/ShowAllIln';
import Tooltips from './modules/Tooltips';

nodeListForEach();

const inits = (): void => {
  Accordeon.init();
  Menu.init();
  Pills.init();
  SlideBox.init();
  VideoPlay.init();
  Slider.init();
  Tabs.init();
  ScrollToTop.init();
  IlnOverflow.init();
  Header.init();
  ShowAllIln.init();
  Tooltips.init();

  document.body.classList.remove('body-loading');
  setTimeout(() => {
    document.body.classList.add('body-loaded');
  }, 200);
};

const onScroll = (e: Event): void => {};

const onResize = (e: Event): void => {
  onScroll(e);
};

const onLoad = (e: Event): void => {
  inits();
  onResize(e);
};

window.addEventListener('load', onLoad);
window.addEventListener('resize', onResize);
window.addEventListener('scroll', onScroll);
